import { render } from "./shop-ndss.vue?vue&type=template&id=07490e1d&scoped=true"
import script from "./shop-ndss.vue?vue&type=script&lang=js"
export * from "./shop-ndss.vue?vue&type=script&lang=js"

import "./shop-ndss.vue?vue&type=style&index=0&id=07490e1d&lang=css"
import "./shop-ndss.vue?vue&type=style&index=1&id=07490e1d&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07490e1d"]])

export default __exports__